import { AbstractEntity } from '../abstract-entity/abstract-entity';
import { Question } from './question';

/**
 * è¯é¢èç¹
 */
export class QuestionNode extends AbstractEntity {
  /**
   * ç¶èç¹id
   */
  parentId: number;

  /**
   * åå»ºäºº
   */
  createAccountId: number;

  /**
   * æ´æ°äºº
   */
  updateAccountId: number;

  /**
   * èµæºid
   */
  resId: string;

  /**
   * æ¯å¦æä»¶å¤¹
   */
  folder = false;

  /**
   * è¯é¢
   */
  question: Question;

  constructor() {
    super();
    this.question = new Question();
  }
}
